module.exports = function(gantt) {
	delete gantt.addTaskLayer;
	delete gantt.addLinkLayer;
};


//////////////////
// WEBPACK FOOTER
// ./sources/core/data_task_layers.gpl.js
// module id = 51
// module chunks = 0